// extracted by mini-css-extract-plugin
export default {"InnerForm":"UpdatePW_InnerForm__WlgbS","PasswordUpdate":"UpdatePW_PasswordUpdate__hX44f","Mt":"UpdatePW_Mt__4TaGp","ChangePassword":"UpdatePW_ChangePassword__5QtXw"};